import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { }   from '@modules/customer/components/dashboard';


const customerModuleRoutes: Routes = [
    
       //{path:'',component:CustomerDashboardComponent,data:{title:'Customer Dashboard'}}
];

@NgModule({
    imports: [RouterModule.forChild(customerModuleRoutes)],
    
})

export class CustomerDashboardRoutingModule { }
